export default "__VITE_ASSET__9d4f0d55__"